import { forwardRef } from 'react';
import { useTheme } from '@mui/material/styles';
import Button from '@mui/material/Button';
import { useMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

const NavigationButton = forwardRef(
	({ activeKey, sx, children, ...props }, ref) => {
		const { palette } = useTheme();
		const isActive = useMatch(activeKey);

		const activeNavigationButtonStyling = {
			color: palette.secondary.main,
			borderBottom: `3px solid ${palette.secondary.main}`,
		};

		return (
			<Button
				{...props}
				variant='text'
				size='small'
				sx={{
					borderRadius: 0,
					height: 48,
					color: 'text.primary',
					borderBottom: '3px solid transparent',
					...(isActive ? activeNavigationButtonStyling : {}),
					...sx,
				}}
				ref={ref}
			>
				{children}
			</Button>
		);
	}
);

NavigationButton.propTypes = {
	/**
	 * The key to match the current route inorder to apply active styling
	 */
	activeKey: PropTypes.string.isRequired,
	/**
	 * Additional styles to add to the button
	 */
	sx: PropTypes.object,
	/**
	 * Children to be wrapped by the component
	 */
	children: PropTypes.node.isRequired,
};

NavigationButton.defaultProps = {
	sx: {},
};

export default NavigationButton;
